import { useEffect, useState } from 'react'
import { Box, Button, Group } from '@mantine/core'
import { useMedplum } from '@medplum/react'
import { PatientSelect } from './components/PatientSelect'
import { Patient, Slot, Encounter } from '@medplum/fhirtypes'
import { formatPatientName } from '@/utils.ts'
import { UpcomingAppointmentsGrid } from './components/UpcomingAppointmentsGrid'
import { IconReplaceUser, IconCalendarPlus } from '@tabler/icons-react'
import { BookAppointmentStepper } from './components/BookAppointmentStepper'
import { PatientDemographics } from './components/PatientDemographics'

type SlotBookingResult = {
  success: boolean
  slot?: Slot
  practitionerName?: string
  patientName?: string
}
export const CallCenterHome = () => {
  const [completeBookedSlot, setCompleteBookedSlot] = useState<SlotBookingResult | null>(null)
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null)
  const [isStepperActive, setIsStepperActive] = useState<boolean>(false)
  const [selectedSlotToEdit, setSelectedSlotToEdit] = useState<Encounter | null>(null)
  const medplum = useMedplum()

  const refetchPatientData = async () => {
    if (selectedPatient && selectedPatient.id) {
      const updatedPatient = await medplum.readResource('Patient', selectedPatient.id)
      setSelectedPatient(updatedPatient)
    }
  }
  const handlePatientChange = (patient: Patient | null): void => {
    setSelectedPatient(patient)
    setIsStepperActive(false)
    setCompleteBookedSlot(null)
  }
  useEffect(() => {
    if (selectedSlotToEdit && isStepperActive === false) {
      setIsStepperActive(true)
    }
  }, [selectedSlotToEdit])
  if (selectedPatient === null) {
    return (
      <section className="full-width full-height flex flex-col items-center">
        <div className="mx-20 mt-20">
          <h1 className="mb-4 text-center text-[25px]">Select a Patient</h1>
          <PatientSelect
            setSelectedPatient={handlePatientChange}
            placeholder={'Search patient by name'}
          />
        </div>
      </section>
    )
  }
  return (
    <section className="mx-auto max-w-[1500px]">
      <Box className="mx-20 mt-20">
        <Group className="mb-[30px] flex items-center">
          <h1 className="text-xl">
            Selected patient:{' '}
            <strong>
              {selectedPatient
                ? formatPatientName(selectedPatient.name?.[0])
                : 'No patient selected'}
            </strong>
          </h1>
          <Button
            className="ml-auto !px-[10px] !py-[3px]"
            leftSection={<IconReplaceUser size={20} />}
            onClick={() => setSelectedPatient(null)}
            variant="outline"
          >
            {' '}
            {selectedPatient ? 'Change' : 'Select'} Patient{' '}
          </Button>
          <Button
            className="!px-[10px] !py-[3px]"
            leftSection={<IconCalendarPlus size={20} />}
            onClick={() => setIsStepperActive(true)}
            variant="outline"
          >
            {' '}
            Book Appointment{' '}
          </Button>
        </Group>
        <Group align="flex-start">
          <PatientDemographics
            patientData={selectedPatient}
            refetchPatientData={refetchPatientData}
          />
          {selectedPatient && isStepperActive ? (
            <BookAppointmentStepper
              completeBookedSlot={completeBookedSlot}
              setCompleteBookedSlot={setCompleteBookedSlot}
              selectedPatient={selectedPatient}
              setSelectedPatient={setSelectedPatient}
              closeStepper={() => setIsStepperActive(false)}
              slotToReschedule={selectedSlotToEdit}
            />
          ) : (
            <UpcomingAppointmentsGrid
              patientData={selectedPatient}
              setSelectedSlotToEdit={setSelectedSlotToEdit}
            />
          )}
        </Group>
      </Box>
    </section>
  )
}
